import ApiService from "./api.service";

class NewsService extends ApiService {
    getNews(all) {
        return this.get(`api/management/news/${all}`);
    }
}

export default new NewsService();
